import { render } from "./list-user.vue?vue&type=template&id=5d8c4448"
import script from "./list-user.vue?vue&type=script&lang=js"
export * from "./list-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__